<div class="row pb-2">
    <div class="col">
        <h6 class="f-15 font-weight-light">{{ 'customerprojectlist.title' | trans }}</h6>
    </div>
</div>
<div class="row mb-1">
   <div class="col-5">
       <p class="mb-0 text-muted font-weight-lighter">{{ 'customerprojectlist.name' | trans }}</p>
   </div>
   <div class="col-3">
        <p class="mb-0 text-muted font-weight-lighter">{{ 'customerprojectlist.startdate' | trans }}</p>
   </div>
   <div class="col-3">
        <p class="mb-0 text-muted font-weight-lighter">{{ 'customerprojectlist.enddate' | trans }}</p>
   </div>
   
</div>
<div (click)="gotoWorkOnProject(proj)" *ngFor="let proj of customerProjectList" class="row hoverrow user-list-row">
   <div class="col-5">
       <p class="mb-0 text-truncate hover-group lh-25 align-middle">{{proj.title}}</p>
   </div>
   <div class="col-3">
       <p class="mb-0 text-truncate hover-group lh-25 align-middle">{{proj.start_date | date:'yyyy-MM-dd'}}</p>
   </div>
   <div class="col-3">
       <p class="mb-0 text-truncate hover-group lh-25 align-middle">{{proj.end_date | date:'yyyy-MM-dd'}}</p>
   </div>
</div>
